let language = {
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_COUPON_CODE: "Coupon Code:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_TAX: "Tax:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_IMPORT_SERVICE_FEE: "Import Service:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_SHIPPING: "Shipping:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_PRODUCTS: "Products and Services:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_DISCOUNT: "Discount:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_TOTAL_DUE: "Total Due:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_PAYMENT_METHOD: "Payment Method:",
    
    
    // 
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_REDEEM_BTN: "Redeem",

    BULK_ORDER_CHECKOUT_STEP_PAYMENT_USED_TIPS:"coupon has been successfully applied."
};

export { language }